import { FC, useContext, useEffect } from "react";

import { ProductCard as UIProductCard } from "@jti/ui/components/ProductCard";
import { ProductCardContainerContext } from "@jti/ui/components/ProductCardContainerContextProvider/ProductCardContainerContextProvider.js";
import { useConfig } from "@jti/ui/providers/useConfig";
import { useTranslations } from "@jti/ui/providers/useTranslations";

export const ProductCard: FC<{
  sku: string;
  title?: string;
  description?: string;
  image?: { src: string; alt: string };
  colors?: string[];
  primaryButton?: { text?: string; href?: string; enabled: boolean };
  secondaryButton?: { text: string; href: string };
  badge?: {
    left?: string;
    right?: string;
  };
}> = ({
  sku,
  title,
  description,
  image,
  colors,
  primaryButton,
  secondaryButton,
  badge,
}) => {
  const { __ } = useTranslations();
  const { hideTeaserConfigurableOptions } = useConfig();
  const {
    addToSkuList,
    products: dynamicDataProducts,
    currency,
    isProductsDataLoading,
  } = useContext(ProductCardContainerContext);

  useEffect(() => {
    addToSkuList?.(sku);
  }, [addToSkuList, sku]);

  const productDynamicData = dynamicDataProducts?.[sku];

  const rightBadge =
    productDynamicData?.isInStock === false
      ? __("libs.ui.out_of_stock.title")
      : "";

  return (
    <UIProductCard
      currency={currency}
      title={title || productDynamicData?.productData?.name || ""}
      description={description || productDynamicData?.productData?.description}
      image={{
        src: image?.src || productDynamicData?.productData?.image,
        alt: `Image of ${title}`,
      }}
      colors={
        !hideTeaserConfigurableOptions
          ? colors || productDynamicData?.productData?.colors
          : []
      }
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      badge={{
        left: badge?.left,
        right: badge?.right || rightBadge,
      }}
      discount={productDynamicData?.discount}
      oldPrice={productDynamicData?.oldPrice}
      currentPrice={productDynamicData?.currentPrice}
      isLoading={isProductsDataLoading}
    />
  );
};
